import { FC } from 'react'
import IconCircle from '@/components/Atoms/Icons/IconCircle'
type TypeIcons = {
  id: number
  width?: number
  height?: number
}
const IconsSelector: FC<TypeIcons> = ({ id, height, width }) => {
  return (
    <>
      {id === 3 && (
        <IconCircle
          height={height}
          width={width}
          color='#FF3E00'
        />
      )}
      {id === 2 && (
        <IconCircle
          height={height}
          width={width}
          color='#FF7F24'
        />
      )}
      {id === 1 && (
        <IconCircle
          height={height}
          width={width}
          color='#FFD21E'
        />
      )}
    </>
  )
}

export default IconsSelector
